import '../css/app.css'

import $ from 'jquery'
window.$ = window.jQuery = $

import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import Headroom from 'headroom.js'

var header = document.querySelector('#main-nav')
var headroomOptions = {
  offset: 0,
  tolerance: {
    up: 0,
    down: 0,
  },
  classes: {
    initial: 'header--fixed',
    pinned: 'slideDown',
    unpinned: 'slideUp',
    top: 'top',
    notTop: 'not-top',
  },
}

// construct an instance of Headroom, passing the element
var headroom = new Headroom(header, headroomOptions)
// initialise
headroom.init()

// When the page is at the top, remove the slideDown class.
window.addEventListener('scroll', () => {
  if (window.pageYOffset === 0) {
    header.classList.remove('slideDown')
  }
})

// END HEADROOM

import Splide from '@splidejs/splide'

new Splide('#announcement', {
  type: 'loop',
  perPage: 1,
  autoplay: true,
  pagination: false,
  arrows: false,
  interval: 3000,
  pauseOnHover: true,
  pauseOnFocus: true,
}).mount()

if ($('#related').length > 0) {
  new Splide('#related', {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    autoplay: false,
    gap: '1em',
    pagination: false,
    arrows: true,
    breakpoints: {
      1024: {
        perPage: 3,
      },
      768: {
        perPage: 2,
      },
      640: {
        perPage: 1,
      },
    },
  }).mount()
}

if ($('#testimonials').length > 0) {
  new Splide('#testimonials', {
    type: 'fade',
    rewind: 'true',
    perPage: 1,
    perMove: 1,
    autoplay: true,
    gap: '1em',
    pagination: true,
    arrows: true,
    paginationDirection: 'ltr',
    arrows: true,
    interval: 4000,
    pauseOnHover: true,
    pauseOnFocus: true,
  }).mount()
}

if ($('#homeBrand').length > 0) {
  new Splide('#homeBrand', {
    type: 'fade',
    rewind: 'true',
    autoplay: true,
    interval: 10000,
    pauseOnHover: true,
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    pauseOnHover: true,
    pauseOnFocus: true,
  }).mount()
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
